import { contactData } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
              投稿与合作
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {contactData.description}
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {contactData.methods.map((method) => (
              <div
                key={method.label}
                className="flex flex-col items-center text-center p-5 bg-background-100 rounded-lg border border-background-200/60"
              >
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 mb-3">
                  <i className={`${method.icon} text-lg text-primary-500`}></i>
                </span>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1.5">{method.label}</h3>
                <p className="text-xs text-foreground-500 break-all">{method.value}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}